import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { WrapWordsInSpans, SimpleInView, SetInitRandomPositions, SetInitSimplePositions, InViewTrigger, OnScrollAnimation, FloatingAnimation } from "./Helpers";

export default class GeneralAnimations {
  constructor() {
    this.splitElements = document.querySelectorAll('[data-split-words]');
    this.textToAnim = '[data-split-words]';
    this.mouseParallaxElements = "[data-mousemove-target]";

    this._init();
  }

  _init() {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.clearScrollMemory( "manual" );

    this._splitWords();
    this._defineRandomDir();
    this._initAnimations();
    this._events();

  }

  _events() {
    window.addEventListener('mousemove', e => {
      this._mouseParallax(e);
    });
  }

  _splitWords() {
    this.splitElements.forEach(el => {
      WrapWordsInSpans(el);

      const words = el.querySelectorAll('.word');

      words.forEach(word => {
          if(el.hasAttribute('data-init-animation')) {
            word.setAttribute('data-init-animation', 'element')
          }

          if(el.hasAttribute('data-scroll-animation')) {
            word.setAttribute('data-scroll-animation', 'spread')
          }
        });
    });
  }

  _defineRandomDir() {
    const elements = gsap.utils.toArray(['[data-init-animation]', '[data-mousemove-target]']);

    elements.forEach((item) => {
      item.randomMouseX = gsap.utils.random(-.2,  .2);
      item.randomMouseY = gsap.utils.random(-.2,  .2);
      item.randomScrollX = gsap.utils.random(-.1,  .1);
      item.randomScrollY = gsap.utils.random(-.1,  .1);
      item.randomRotate = gsap.utils.random(-15,  15);
    });
  }

  _mouseParallax(e) {
    FloatingAnimation(e, this.mouseParallaxElements)
  }

  _initAnimations() {
    const batchTrigger = gsap.utils.toArray(['[data-init-animation="container"]']);
    const radomSetterElements = gsap.utils.toArray(['[data-init-animation="element"]:not([data-simple-animation])']);
    const simpleSetterElements = gsap.utils.toArray(['[data-simple-animation]']);

    const setElementsBatch = batch => {
      const batchElements = [];

      batch.forEach(el => {
        const items = el.querySelectorAll('[data-init-animation="element"]');
        items.forEach(item => batchElements.push(item));
      })

      return batchElements;
    }

    const onComplete = (batchElements) => batchElements.forEach(this._scrollParallax.bind(this));

    if(radomSetterElements.length) {
      SetInitRandomPositions(radomSetterElements);
      InViewTrigger(batchTrigger, setElementsBatch, onComplete);
    }

    if(simpleSetterElements.length) {
      SetInitSimplePositions(simpleSetterElements);
      SimpleInView(simpleSetterElements);
    }
  }

  _scrollParallax(item) {
    let trigger = item.closest('[data-scroll-animation="spread-trigger"]');

    if(!trigger) return;

    gsap.set(item, {
      x: 0,
      y: 0,
      rotation: 0
    });

    const header = document.querySelector('.topbar');
    const headerHeight = header.offsetHeight;
    const itemBoundingRectTop = item.parentNode.getBoundingClientRect().top;


    let itemStart = 0;
    let toTop = window.innerHeight * gsap.utils.random(-.5, -1);
    let toLeft = window.innerHeight * (item.randomScrollX * 10);
    let toRot = window.innerHeight * item.randomRotate / 200;
    let toScale = gsap.utils.random(1, .3);

    if(trigger.hasAttribute('data-illustration') ||
       trigger.hasAttribute('data-mobile-illustration')) {

      itemStart = itemBoundingRectTop < window.innerHeight / 2 ? itemBoundingRectTop - 10 : window.innerHeight / 2;
      toTop = window.innerHeight * gsap.utils.random(-.5, -1)
      toLeft = window.innerHeight * (item.parentNode.randomScrollX * 10);
      toRot = window.innerHeight * item.parentNode.randomRotate / 200;
    }

    OnScrollAnimation(trigger, item, itemStart, toTop, toLeft, toRot, toScale);
  }
}
